<template>
  <!-- <v-container grid-list-md fluid> -->
    <!-- <v-slide-y-transition mode="out-in"> -->
      <v-layout row >
        <v-flex md12>
          <v-card>
            <v-toolbar dense primary-title>
              <v-toolbar-title>
                {{$t('view.usuario.registros.label')}}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="view.elem.showTable = !view.elem.showTable">
                <v-icon>{{ view.elem.showTable ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
              </v-btn>
            </v-toolbar>
            <v-slide-y-transition>
              <v-card-text v-show="view.elem.showTable">
                <v-layout row>
                  <v-flex md12>
                    <table id="something" class="table table-striped table-bordered table-hover dataTables-example responsive " style="width:100%;" >
                      <thead>
                        <tr>
                          <th class="all"></th>
                          <th class="all">Nombre (Usuario)</th>
                          <th class="all">Acciones</th>
                        </tr>
                      </thead>
                    </table>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-slide-y-transition>
          </v-card> 
        </v-flex>       
      </v-layout>
    <!-- </v-slide-y-transition> -->
  <!-- </v-container> -->
</template>
<script>
import UsuarioAPI from "@/services/seguridad/usuario";
import {handleResponseMessage} from '@/helpers/http-response-handler';
import tippy from 'tippy.js';

export default {
  data() {
    return {
      count:0
      , dataTable:undefined
      , view:{
        elem:{
          showTable: true
        }
      }
    }
  }
  , props:{
    pageLength:{
      default:10
      , type:Number
    }
    , responsive:{
      default:true
      , type:Boolean
    }
    , dom:{
      default:'<"html5buttons"B>lTfgitp'
    } 
  }
  ,methods: {
    async deleteRow(username){
      console.log(username)
      try{
        const swalResponse = await this.$swal({
          title: this.$t('view.global.swal.disable.title')
          , text: this.$t('view.global.swal.disable.text')
          , type: this.$t('view.global.swal.disable.type')
          , showCancelButton: this.$t('view.global.swal.disable.showCancelButton')
          , confirmButtonColor: this.$t('view.global.swal.disable.confirmButtonColor')
          , cancelButtonColor: this.$t('view.global.swal.disable.cancelButtonColor')
          , confirmButtonText: this.$t('view.global.swal.disable.confirmButtonText')
          , cancelButtonText: this.$t('view.global.swal.disable.cancelButtonText')
          , reverseButtons: true
        });
        if(swalResponse.value){
          const response = await UsuarioAPI.disable({username});
          handleResponseMessage({response: response,modulo:'Usuarios'});
          this.$parent.initialState();
           
        }
      }catch(error){
        console.log(error)
      }
    }
    , refreshData(){
      this.dataTable._fnAjaxUpdate();
    }
  }
  , computed:{}
  , components: {}
  // Instance Lifecycle Hooks
  , created(){
    //window.$('.dataTables-example').DataTable({});  
  }
  , mounted(){
    const vm = this;
    function emitEventDeleteRow(event){
      const {username} = this;
      console.log(username)
      vm.deleteRow(username)
      .then(response=>{
        vm.dataTable._fnAjaxUpdate();
      })
      .catch(console.log);
    }
    function emitEventEditRow(event){
      const {id} = this;
      vm.$emit('editRow', id);
    };
    function emitEventShowPerfiles(event){
      const {id} = this;
      vm.$emit('showPerfiles', id, this.dataset.nombre);
    }
    function emitEventAuditRow(event){
      const {audit,dataDescripcion} = this;
      vm.$emit('auditRow', audit,dataDescripcion);
    };
    function newUserPhoto(imageBase64){
      const img = document.createElement('img');
      //img settings
      img.setAttribute("src",imageBase64);
      img.setAttribute("width","40px");
      img.classList.add("img-circle");
      img.classList.add("animated");
      img.classList.add("picture-pulse");
      return img;
    }
    function newDeleteButton(id,eventFunction){
      const button = document.createElement('button');
      const link = document.createElement('i');
      const label = document.createElement('span');
      //button settings
      button.setAttribute("title","Desactivar");
      button.classList.add('btn', 'btn-action-delete', 'button', 'button--sacnite', 'button--round-l', 'custom');
      button.id = id || "";
      button.username = id || "";
      button.onclick = eventFunction;
      //link
      link.classList.add('button__icon', 'icon', 'fa', 'fa-trash-o');
      //label settings
      label.appendChild(document.createTextNode('delete'))
      //Append link and label within the button
      button.appendChild(link);
      button.appendChild(label);
      
      return button;
    };
    function newEditButton(id,eventFunction){
      const button = document.createElement('button');
      const link = document.createElement('i');
      const label = document.createElement('span');
      //button settings
      button.setAttribute("title","Editar");
      button.classList.add('btn', 'btn-action-edit', 'button', 'button--sacnite', 'button--round-l', 'custom');
      button.id = id || "";
      button.onclick = eventFunction;
      //link
      link.classList.add('button__icon', 'icon', 'fa', 'fa-pencil');
      //label settings
      label.appendChild(document.createTextNode('edit'))
      //Append link and label within the button
      button.appendChild(link);
      button.appendChild(label);
      
      return button;
    };
    function newAuditButton(id,dataDescripcion,eventFunction){
      const button = document.createElement('button');
      const link = document.createElement('i');
      const label = document.createElement('span');
      //button settings
      button.setAttribute("title","Auditoría");
      button.classList.add('btn', 'button', 'button--sacnite', 'button--round-l', 'custom');
      button.audit = id || "";
      button.dataDescripcion = dataDescripcion || "";
      button.username = id || "";
      button.onclick = eventFunction;
      //link
      link.classList.add('button__icon', 'icon', 'fa', 'fa-database');
      //label settings
      label.appendChild(document.createTextNode('audit'))
      //Append link and label within the button
      button.appendChild(link);
      button.appendChild(label);
      
      return button;
    };
    function newPerfilesButton(id,nombre,eventFunction){
      const button = document.createElement('button');
      const link = document.createElement('i');
      const label = document.createElement('span');
      //button settings
      button.setAttribute("title","Perfiles");
      button.classList.add('btn', 'button', 'button--sacnite', 'button--round-l', 'custom');
      button.id = id || "";
      button.dataset.nombre=nombre || "";
      button.onclick = eventFunction;
      //link
      link.classList.add('button__icon', 'icon', 'mdi', 'mdi-account-plus');
      //label settings
      label.appendChild(document.createTextNode('delete'))
      //Append link and label within the button
      button.appendChild(link);
      button.appendChild(label);
      
      return button;
    };
    this.$nextTick(function(){
      
      vm.dataTable=window.$('#something').dataTable({     
        "bProcessing": true
        , "bServerSide": true
        , "bPaginate":true
        , "pageLength" : vm.pageLength
        , "responsive": true
        , "language": { "url": '/static/js/dataTables/language/dataTables.spanish.json' }
        , "ajax":{
          "url": "/api/usuario/list"
          , "type": "POST"
          , "async":true
          ,"headers":{
            "Authorization":`Bearer ${vm.$store.getters.getUserToken}`
          }
          , "data"    : function(data){}
          , "complete": function(response){}
          , "error"   : function(error){}
        }
        , "fnRowCallback": function( nRow, aData, iDisplayIndex, iDisplayIndexFull ) {
          nRow.cells[2].textContent = null;
          nRow.cells[2].appendChild(newPerfilesButton(aData['username'], aData['nombre'], emitEventShowPerfiles));
          nRow.cells[2].appendChild(newEditButton(aData['username'], emitEventEditRow));
          nRow.cells[0].textContent=null;
         // nRow.cells[0].appendChild(aData['username'])
          nRow.cells[0].appendChild(newUserPhoto(aData['foto_miniatura']))
          if(aData.enabled && vm.$userPermission.hasPermission('ROLE_MODIFICAR_SEGURIDAD')) 
            nRow.cells[2].appendChild(newDeleteButton(aData['username'], emitEventDeleteRow));
            
          if(vm.$userPermission.hasPermission('ROLE_ACCESO_AUDITORIA'))
            nRow.cells[2].appendChild(newAuditButton(aData['username'], aData['nombre'], emitEventAuditRow));
        }
        , "fnDrawCallback": function (oSettings) {
          tippy('.btn', {
            arrow: true,
            arrowType: 'round',
            size: 'large',
            animation: 'scale'
          });
        }
        , "aoColumns": [
          {
            "data":"username"
            , "sClass":"text-center"
          }
          , {
            "data":"nombre"
            , "sClass":"text-center"
          }
          , {
            "data":"enabled"
            , "sClass":"text-center"
          }
        ]
        , "aoColumnDefs":[
          {
            "aTargets": [1],
            "mData": "status",
            "mRender": function ( data, type, full ) {
              return data + ' ('+full.username+')';
            }
          }
          , {
            "aTargets": [2],
            "mData": "status",
            "searchable": false,
            "sorting": false,
            "orderable": false,
            "mRender": function ( data, type, full ) {
              return data;
            }
          }
        ]
      });

      tippy('.btn', {
            arrow: true,
            arrowType: 'round',
            size: 'large',
            animation: 'scale'
          });
    });

  }
};


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/seguridad/usuario/DataTable.vue